<template>
  <figure class="c-missing-image">
    <MissingImageIcon />
    <figcaption><slot /></figcaption>
  </figure>
</template>

<script>
import MissingImageIcon from '@/components/icons/MissingImage.vue';

export default {
  name: 'MissingImage',
  components: {
    MissingImageIcon,
  },
};
</script>